export enum AccessLevels {
    superAdmin = 1,
    stationManager = 2,
    agent = 3
}